import { useMutation, useQueryClient } from '@tanstack/react-query';

interface DeleteCandidateFormItemParams {
  candidateFormId: number;
  candidateFormItemId: number;
}

/**
 * candidate_form_item削除用のフック
 */
export default function useDeleteCandidateFormItem() {
  const queryClient = useQueryClient();
  const token =
    (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || '';

  return useMutation({
    mutationFn: async (params: DeleteCandidateFormItemParams) => {
      const { candidateFormId: _candidateFormId, candidateFormItemId } = params;

      const response = await fetch(
        `/agent/api/candidate_forms/candidate_form_items/${candidateFormItemId}`,
        {
          method: 'DELETE',
          headers: {
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          credentials: 'same-origin',
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.errors?.[0] || '項目の削除に失敗しました');
      }

      return true;
    },
    onSuccess: () => {
      // フォーム一覧のキャッシュを無効化して再取得
      queryClient.invalidateQueries({ queryKey: ['candidate_forms'] });
    },
  });
}
